"use client"

import { ProfileCommunity } from "@/app/entities/BFF/ProfileShort"
import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

/**
 * 내 프로필 조회 (client side)
 */
const fetchClientMyProfile = () =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/account/profile`).then(resultPostprocessing2<ProfileCommunity>)

export default fetchClientMyProfile
